import React from 'react';
import './Legal.css';

const AvisoPrivacidad = () => {
  return (
    <div className="legal-container">
      <div className="legal-content">
        <h1>Aviso de Privacidad</h1>
        <p className="legal-fecha">Última actualización: 12 de octubre de 2026</p>
        <p><a href="/privacy-policy">Read this notice in English</a></p>

        <section>
          <h2>1. Responsable del tratamiento de datos</h2>
          <p>
            <strong>Xaltech Manufacturing Services SA de CV</strong>, en adelante "la Empresa" o "Xaltech Fotos",
            con correo electrónico de contacto: <strong>xaltech1990@outlook.com</strong>, es responsable del
            tratamiento de sus datos personales. Xaltech Fotos opera una plataforma digital que presta
            servicios a fotógrafos y atletas tanto en México como en otros países, por lo que este aviso
            busca seguir un estándar internacional de protección de datos.
          </p>
          <p>
            Como marco principal aplicamos la Ley Federal de Protección de Datos Personales en Posesión de
            los Particulares (LFPDPPP) de México y su Reglamento. Adicionalmente, cuando la ley aplicable a
            su caso lo requiera, reconocemos derechos equivalentes a los previstos por el Reglamento General
            de Protección de Datos de la Unión Europea (RGPD/GDPR) y por la Ley de Privacidad del Consumidor
            de California (CCPA/CPRA); vea la sección 6.
          </p>
        </section>

        <section>
          <h2>2. Datos personales que recabamos</h2>
          <p>Para los <strong>fotógrafos</strong> registrados en la plataforma:</p>
          <ul>
            <li>Nombre completo</li>
            <li>Correo electrónico</li>
            <li>Número de teléfono</li>
          </ul>
          <p>Para los <strong>atletas / compradores</strong> que usan el servicio vía WhatsApp:</p>
          <ul>
            <li>Número de teléfono de WhatsApp</li>
            <li>Número de corredor o dorsal</li>
            <li>Información de pago procesada por Stripe (no almacenamos datos de tarjetas)</li>
          </ul>
        </section>

        <section>
          <h2>3. Finalidades del tratamiento</h2>
          <p>Sus datos son utilizados para:</p>
          <ul>
            <li>Identificar y entregar fotografías de eventos deportivos al corredor correspondiente</li>
            <li>Procesar pagos a través de Stripe</li>
            <li>Gestionar la relación comercial con fotógrafos registrados</li>
            <li>Enviar notificaciones relacionadas con sus fotos vía WhatsApp</li>
            <li>Cumplir con obligaciones fiscales y legales</li>
          </ul>
        </section>

        <section>
          <h2>4. Transferencia de datos</h2>
          <p>
            Sus datos personales no serán transferidos a terceros sin su consentimiento, salvo las excepciones
            previstas en el Artículo 37 de la LFPDPPP, incluyendo procesadores de pago (Stripe) y
            proveedores de infraestructura tecnológica (Microsoft Azure) bajo acuerdos de confidencialidad.
          </p>
          <p>
            <strong>Transferencia internacional:</strong> nuestra infraestructura tecnológica (Microsoft Azure) aloja
            los datos en centros de datos ubicados en Estados Unidos. Al utilizar nuestros servicios, usted
            consiente esta transferencia internacional, realizada bajo los acuerdos de protección de datos que
            Microsoft Azure ofrece a sus clientes empresariales.
          </p>
          <p>
            Si usted participa en un evento realizado fuera de México, sus datos también podrán transferirse
            y procesarse en el país donde se organice dicho evento, aplicando en todos los casos medidas de
            seguridad razonables para proteger su información.
          </p>
        </section>

        <section>
          <h2>5. Datos biométricos (reconocimiento facial)</h2>
          <p>
            Para los eventos que ofrecen búsqueda de fotografías por selfie, procesamos un <strong>dato personal
            sensible</strong> conforme al Artículo 3, fracción VI de la LFPDPPP: un patrón matemático (embedding)
            derivado de su rostro, utilizado exclusivamente para comparar su selfie contra los rostros detectados
            en las fotografías del evento al que acudió.
          </p>
          <ul>
            <li>No almacenamos la imagen de su selfie; únicamente el patrón matemático generado a partir de ella.</li>
            <li>Este dato se usa exclusivamente para la búsqueda de sus fotografías en el evento correspondiente, nunca para otro fin.</li>
            <li>Se elimina automáticamente si el evento es dado de baja de la plataforma, o antes si usted lo solicita.</li>
            <li>Recabamos este dato únicamente mediante consentimiento expreso, solicitado de forma separada antes de procesar cualquier selfie.</li>
          </ul>
          <p>
            Si la selfie corresponde a una persona menor de edad, quien la envía declara ser su padre, madre o
            tutor legal y otorgar el consentimiento en su representación.
          </p>
        </section>

        <section>
          <h2>6. Derechos ARCO y derechos equivalentes en otras jurisdicciones</h2>
          <p>
            Si usted se encuentra en México, tiene derecho a <strong>Acceder, Rectificar, Cancelar u
            Oponerse</strong> al tratamiento de sus datos personales (derechos ARCO), conforme a la LFPDPPP.
            Para ejercerlos, envíe un correo a <strong>xaltech1990@outlook.com</strong> con el asunto
            "Derechos ARCO", indicando su nombre completo y la solicitud específica. Responderemos en un
            plazo máximo de 20 días hábiles.
          </p>
          <p>
            Si usted reside en el <strong>Espacio Económico Europeo, Reino Unido o Suiza</strong>, puede
            ejercer derechos equivalentes conforme al RGPD/GDPR: acceso, rectificación, supresión,
            limitación del tratamiento, portabilidad y oposición. Si reside en <strong>California,
            Estados Unidos</strong>, puede ejercer los derechos previstos por la CCPA/CPRA: conocer, eliminar
            y no ser discriminado por ejercer estos derechos (Xaltech Fotos no vende datos personales a
            terceros con fines de mercadotecnia).
          </p>
          <p>
            Para solicitudes amparadas en el RGPD o la CCPA, escriba también a{' '}
            <strong>xaltech1990@outlook.com</strong> indicando la ley bajo la cual ejerce su derecho;
            atenderemos su solicitud en un plazo razonable conforme a la legislación aplicable.
          </p>
        </section>

        <section>
          <h2>7. Fotografías en eventos públicos y privados</h2>
          <p>
            Las fotografías de <strong>eventos deportivos de carácter público</strong> (carreras, triatlones, etc.)
            son tomadas donde los participantes han sido registrados previamente por los organizadores del evento.
            La toma fotográfica en espacios públicos y eventos de acceso general está permitida conforme a la
            legislación mexicana vigente.
          </p>
          <p>
            En el caso de <strong>eventos privados</strong> (bodas, graduaciones, baby showers y similares), el
            fotógrafo que sube las imágenes a la plataforma declara contar con la autorización del organizador y,
            en su caso, de los asistentes fotografiados, para captar y comercializar dichas imágenes a través de
            Xaltech Fotos.
          </p>
          <p>
            Si el evento se realiza fuera de México, el fotógrafo es responsable de cumplir también con la
            legislación local aplicable en materia de imagen y datos personales del país donde se realice
            el evento.
          </p>
          <p>
            En caso de requerir la eliminación de alguna imagen, contáctenos a
            <strong> xaltech1990@outlook.com</strong>.
          </p>
        </section>

        <section>
          <h2>8. Cookies y tecnologías de rastreo</h2>
          <p>
            Nuestro sitio web puede utilizar cookies de sesión para mantener el estado de autenticación.
            No utilizamos cookies de rastreo publicitario de terceros.
          </p>
        </section>

        <section>
          <h2>9. Cambios al aviso de privacidad</h2>
          <p>
            Nos reservamos el derecho de modificar este aviso en cualquier momento. Los cambios serán
            notificados a través de nuestra plataforma web en <strong>xaltechphotos.xaltech.online</strong>.
          </p>
        </section>

        <section>
          <h2>10. Contacto</h2>
          <p>
            Para cualquier duda o comentario relacionado con este aviso de privacidad, contáctenos en:<br />
            📧 <strong>xaltech1990@outlook.com</strong><br />
            🌐 <strong>xaltechphotos.xaltech.online</strong>
          </p>
        </section>
      </div>
    </div>
  );
};

export default AvisoPrivacidad;
